import React, { useState, useCallback, useMemo } from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';

// Extracted `getImageUrl` utility (PR review point 10)
export function getImageUrl(url) {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    if (url.startsWith('/media/') || url.startsWith('media/')) {
        const baseUrl = import.meta.env.VITE_API_URL || '';
        return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
    }
    return url;
}

export const PageThumbnail = React.memo(function PageThumbnail({ src, alt, className, fallbackIconSize = "w-12 h-12" }) {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    const handleError = useCallback(() => {
        setError(true);
        setLoading(false);
    }, []);

    const handleLoad = useCallback(() => {
        setLoading(false);
    }, []);

    const imageUrl = useMemo(() => getImageUrl(src), [src]);

    if (error || !imageUrl) {
        return (
            <div className={`flex flex-col items-center justify-center bg-theme-elevated w-full h-full ${className || ''}`}>
                <PhotoIcon className={`${fallbackIconSize} text-theme-muted`} />
                <span className="text-xs text-theme-muted mt-2">No preview</span>
            </div>
        );
    }

    return (
        <>
            {loading && (
                <div className="absolute inset-0 flex items-center justify-center bg-theme-elevated">
                    <div className="w-6 h-6 border-2 border-theme-primary border-t-brand-orange rounded-full animate-spin" />
                </div>
            )}
            <img
                src={imageUrl}
                alt={alt}
                loading="lazy"
                className={`${className || ''} ${loading ? 'opacity-0' : 'opacity-100'} transition-opacity`}
                onError={handleError}
                onLoad={handleLoad}
            />
        </>
    );
});
